import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import {
    IAccountRechargeDetail,
    IAccountRechargeFields, IAccountRechargeSearch, IAccountRechargeSearchParam,
} from "../../../../AccountTypes";
import { accountService } from "../../../../AccountService";
import { useDetailModel } from "../detailModel";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/utils/utils";

export const useRechargeModel = createModel(function () {
    const initSearchParam: IAccountRechargeSearchParam = {};
    const initDataSource: IAccountRechargeDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { supplierCode } = useDetailModel();
    const { user: { shopCode } } = useGlobalModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountRechargeSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountRechargeDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountRechargeDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    // 充值总额
    const [rechargeAmount, setRechargeAmount] = useState<number>(0)


    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }
    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountRechargeFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountRechargeSearchParam = searchParam) => {

        const searchParams: IAccountRechargeSearch = {
            ...searchValue,
            partnerCode: supplierCode,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            shopCode,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.rechargePage(searchParams);
        let { retData: totalRetData } = await accountService.rechargeTotalAmount(searchParams)
        const { records, ...pg } = retData;
        setRechargeAmount(totalRetData)
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }


    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        rechargeAmount,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        onSearch,
        onReset,
        setSelectedData,
    }
});
